// Where the browser should reach the agent-server (agent-server/), derived from
// where the app itself is loaded — so the Repo/Advisor consoles work both
// locally and over the Tailscale tailnet with zero configuration.
//
//   • Loaded over the private tailnet (MagicDNS *.ts.net, HTTPS): the
//     agent-server is published by `tailscale serve` on :8443 of the SAME host.
//   • Local dev: the agent-server is on loopback :4100.
//
// See scripts/remote-access.sh and REMOTE_ACCESS.md.

const AGENT_SERVE_PORT = 8443; // tailnet HTTPS port (mirrors remote-access.sh)
const LOCAL_BACKEND = process.env.REACT_APP_AGENT_BACKEND || 'http://127.0.0.1:4100';
// An old hardcoded default that may still be cached in someone's localStorage;
// treat it as stale so we re-derive instead of pointing at a dead :4000.
const OBSOLETE_BACKEND = /:4000(\/|$)/;

function currentLocation(loc) {
  if (loc) return loc;
  return typeof window !== 'undefined' ? window.location : null;
}

function onTailnet(loc) {
  return !!(loc && /\.ts\.net$/i.test(loc.hostname || ''));
}

// The default backend for wherever the app is currently loaded.
export function defaultAgentBackend(loc) {
  const l = currentLocation(loc);
  if (onTailnet(l)) return `https://${l.hostname}:${AGENT_SERVE_PORT}`;
  return LOCAL_BACKEND;
}

// The effective backend. Honors a user override from localStorage, but only when
// it belongs to the same context as where the app is loaded: a value saved
// locally (127.0.0.1) would point a remote browser at its own loopback and fail,
// and vice-versa. For a mismatch — or the obsolete :4000 default — we re-derive.
export function resolveAgentBackend(stored, loc) {
  const l = currentLocation(loc);
  let s = (stored || '').trim();
  if (s && OBSOLETE_BACKEND.test(s)) s = '';
  if (onTailnet(l)) {
    // On the tailnet, talk to this host's :8443 proxy unless the stored override
    // is itself a tailnet URL.
    return /\.ts\.net/i.test(s) ? s : defaultAgentBackend(l);
  }
  return s || defaultAgentBackend(l);
}
